/**
 * @flow
 * @relayHash bfa05d7c7eccfeac80c21f4ab9a4cfde
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PortfolioOrderDetails_portfolioOrder$ref = any;
export type PortfolioOrderDetailsContainerQueryVariables = {|
  portfolioOrderId?: ?string
|};
export type PortfolioOrderDetailsContainerQueryResponse = {|
  +viewer: ?{|
    +sideEnum: ?{|
      +enumValues: ?$ReadOnlyArray<{|
        +description: ?string,
        +name: string,
      |}>
    |},
    +orderTypeEnum: ?{|
      +enumValues: ?$ReadOnlyArray<{|
        +description: ?string,
        +name: string,
      |}>
    |},
    +orderStatusEnum: ?{|
      +enumValues: ?$ReadOnlyArray<{|
        +description: ?string,
        +name: string,
      |}>
    |},
    +portfolioOrderStatusEnum: ?{|
      +enumValues: ?$ReadOnlyArray<{|
        +description: ?string,
        +name: string,
      |}>
    |},
    +exchanges: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +symbol: string,
          +nextDaySession: ?{|
            +startTime: ?any,
            +endTime: ?any,
          |},
        |}
      |}>
    |},
    +portfolioOrders: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +$fragmentRefs: PortfolioOrderDetails_portfolioOrder$ref
        |}
      |}>,
      +count: ?number,
    |},
  |}
|};
export type PortfolioOrderDetailsContainerQuery = {|
  variables: PortfolioOrderDetailsContainerQueryVariables,
  response: PortfolioOrderDetailsContainerQueryResponse,
|};
*/


/*
query PortfolioOrderDetailsContainerQuery(
  $portfolioOrderId: ID
) {
  viewer {
    sideEnum: __type(name: "Side") {
      enumValues {
        description
        name
      }
    }
    orderTypeEnum: __type(name: "OrderType") {
      enumValues {
        description
        name
      }
    }
    orderStatusEnum: __type(name: "OrderStatus") {
      enumValues {
        description
        name
      }
    }
    portfolioOrderStatusEnum: __type(name: "PortfolioOrderStatus") {
      enumValues {
        description
        name
      }
    }
    exchanges {
      edges {
        node {
          symbol
          nextDaySession {
            startTime
            endTime
          }
          id
        }
      }
    }
    portfolioOrders(id: $portfolioOrderId) {
      edges {
        node {
          ...PortfolioOrderDetails_portfolioOrder
          id
        }
      }
      count
    }
    id
  }
}

fragment PortfolioOrderDetails_portfolioOrder on PortfolioOrderNode {
  id
  side
  createdAt
  updatedAt
  status
  bulkOrder {
    id
  }
  portfolio {
    id
    trackingVueName
    trackingVue {
      id
      name
    }
  }
  account {
    id
    name
  }
  tradeInvoice {
    pdf
    pdfUrl
    createdAt
    updatedAt
    state
    id
  }
  stockOrders(orderBy: "createdAt") {
    edges {
      node {
        ...StockOrderDetails_stockOrder
        id
      }
    }
  }
}

fragment StockOrderDetails_stockOrder on StockOrderNode {
  parentOrder {
    id
  }
  id
  orderRef
  status
  pendingStatus
  price
  quantity
  cashQuantity
  side
  createdAt
  updatedAt
  orderType
  quantityToDate
  executedQuantityToDate
  matched
  blockedHoldings
  blockedProceeds
  blockedBaseCharges
  blockedLocalCharges
  customCommission
  advancedOrderType
  actionLogs(orderBy: "actionTime") {
    edges {
      node {
        actionId
        actionType
        actionTime
        actionDescription
        user {
          fullName
          id
        }
        id
      }
    }
  }
  contract {
    id
    currency
    symbol
    name
    industry
    ibConId
    instrumentType
    exchange {
      name
      symbol
      id
    }
  }
  account {
    id
    name
    clientaccount {
      id
      accountType
    }
  }
  portfolioOrder {
    id
  }
  executionSet {
    edges {
      node {
        transaction {
          id
        }
        price
        proceeds
        executionDatetime
        quantity
        currency
        id
      }
    }
  }
  proceedsToDate
  proceedsToDateBase
  brokerOrder {
    id
    twsOrderId
    twsPermId
    cashQuantity
    quantityFilled
    quantityLeft
    stopPrice
    trailStopRatio
    trailStopOffset
    lastSyncTime
    status
    orderRef
    ackedClientOrderId
    brokerSideOrderId
    ibExchange {
      id
      symbol
    }
    algoParams {
      algo
      orderalgoparamstwap {
        strategyType
        startTime
        endTime
        allowPastEndTime
        id
      }
      orderalgoparamsvwap {
        id
        maxVolumeRatio
        startTime
        endTime
        allowPastEndTime
        neverTakeLiquidity
        speedup
      }
      id
    }
    brokerorderamendmentSet(orderBy: "sequence") {
      edges {
        node {
          id
          limitPrice
          previousLimitPrice
          quantity
          previousQuantity
          status
          blockingRevised
          createdAt
          updatedAt
        }
      }
    }
  }
  orderPtr {
    orderapprovalcontractSet {
      edges {
        node {
          id
          approval {
            id
            portfolioOrder {
              id
              status
            }
            createdAt
            updatedAt
            approvedAt
            notifiedAt
            remindedAt
            proposal {
              id
              type
            }
            rationaleUrl
            approvedBy {
              fullName
              id
            }
            status
            portfolio {
              id
              trackingVueName
              account {
                name
                id
              }
            }
            actionLogs {
              edges {
                node {
                  id
                  actionDescription
                  actionId
                  actionTime
                  actionType
                  user {
                    id
                    fullName
                  }
                }
              }
            }
          }
        }
      }
    }
    id
  }
  tradeInvoice {
    id
    pdfUrl
    pdf
    state
    createdAt
    updatedAt
    portfolioOrder {
      id
    }
  }
  transactions {
    edges {
      node {
        id
        commission
        tax
        transactionaccountchargeSet {
          edges {
            node {
              id
              amount
              currency
              feeType
              accountchargePtr {
                accountchargetenantportionSet {
                  edges {
                    node {
                      id
                      quantity
                      tenant {
                        name
                        id
                      }
                    }
                  }
                }
                id
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "portfolioOrderId",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "enumValues",
    "storageKey": null,
    "args": null,
    "concreteType": "__EnumValue",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
      },
      (v1/*: any*/)
    ]
  }
],
v3 = {
  "kind": "LinkedField",
  "alias": "sideEnum",
  "name": "__type",
  "storageKey": "__type(name:\"Side\")",
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "Side"
    }
  ],
  "concreteType": "__Type",
  "plural": false,
  "selections": (v2/*: any*/)
},
v4 = {
  "kind": "LinkedField",
  "alias": "orderTypeEnum",
  "name": "__type",
  "storageKey": "__type(name:\"OrderType\")",
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "OrderType"
    }
  ],
  "concreteType": "__Type",
  "plural": false,
  "selections": (v2/*: any*/)
},
v5 = {
  "kind": "LinkedField",
  "alias": "orderStatusEnum",
  "name": "__type",
  "storageKey": "__type(name:\"OrderStatus\")",
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "OrderStatus"
    }
  ],
  "concreteType": "__Type",
  "plural": false,
  "selections": (v2/*: any*/)
},
v6 = {
  "kind": "LinkedField",
  "alias": "portfolioOrderStatusEnum",
  "name": "__type",
  "storageKey": "__type(name:\"PortfolioOrderStatus\")",
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "PortfolioOrderStatus"
    }
  ],
  "concreteType": "__Type",
  "plural": false,
  "selections": (v2/*: any*/)
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "startTime",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "endTime",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "nextDaySession",
  "storageKey": null,
  "args": null,
  "concreteType": "ExchangeSessionType",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/)
  ]
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "portfolioOrderId"
  }
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "side",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v18 = [
  (v13/*: any*/)
],
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "trackingVueName",
  "args": null,
  "storageKey": null
},
v20 = [
  (v13/*: any*/),
  (v1/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pdf",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pdfUrl",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderRef",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cashQuantity",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionId",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionType",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionTime",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionDescription",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v33 = [
  (v32/*: any*/),
  (v13/*: any*/)
],
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolioOrder",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioOrderNode",
  "plural": false,
  "selections": (v18/*: any*/)
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "allowPastEndTime",
  "args": null,
  "storageKey": null
},
v37 = [
  (v1/*: any*/),
  (v13/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PortfolioOrderDetailsContainerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "exchanges",
            "storageKey": null,
            "args": null,
            "concreteType": "ExchangeNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ExchangeNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExchangeNode",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "portfolioOrders",
            "storageKey": null,
            "args": (v11/*: any*/),
            "concreteType": "PortfolioOrderNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PortfolioOrderNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioOrderNode",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "PortfolioOrderDetails_portfolioOrder",
                        "args": null
                      }
                    ]
                  }
                ]
              },
              (v12/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PortfolioOrderDetailsContainerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "exchanges",
            "storageKey": null,
            "args": null,
            "concreteType": "ExchangeNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ExchangeNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExchangeNode",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v10/*: any*/),
                      (v13/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "portfolioOrders",
            "storageKey": null,
            "args": (v11/*: any*/),
            "concreteType": "PortfolioOrderNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PortfolioOrderNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioOrderNode",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bulkOrder",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BulkOrderNode",
                        "plural": false,
                        "selections": (v18/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "portfolio",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioNode",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "trackingVue",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "VueNode",
                            "plural": false,
                            "selections": (v20/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "account",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccountNode",
                        "plural": false,
                        "selections": (v20/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeInvoice",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeInvoiceNode",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v23/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "stockOrders",
                        "storageKey": "stockOrders(orderBy:\"createdAt\")",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "orderBy",
                            "value": "createdAt"
                          }
                        ],
                        "concreteType": "StockOrderNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StockOrderNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "StockOrderNode",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "parentOrder",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderNode",
                                    "plural": false,
                                    "selections": (v18/*: any*/)
                                  },
                                  (v13/*: any*/),
                                  (v24/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pendingStatus",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "orderType",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "quantityToDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "executedQuantityToDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "matched",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "blockedHoldings",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "blockedProceeds",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "blockedBaseCharges",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "blockedLocalCharges",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "customCommission",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "advancedOrderType",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "actionLogs",
                                    "storageKey": "actionLogs(orderBy:\"actionTime\")",
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "orderBy",
                                        "value": "actionTime"
                                      }
                                    ],
                                    "concreteType": "ActionLogUserRequestNodeConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ActionLogUserRequestNodeEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ActionLogUserRequestNode",
                                            "plural": false,
                                            "selections": [
                                              (v28/*: any*/),
                                              (v29/*: any*/),
                                              (v30/*: any*/),
                                              (v31/*: any*/),
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "user",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "UserNode",
                                                "plural": false,
                                                "selections": (v33/*: any*/)
                                              },
                                              (v13/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "contract",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ContractNode",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v34/*: any*/),
                                      (v7/*: any*/),
                                      (v1/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "industry",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "ibConId",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "instrumentType",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "exchange",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ExchangeNode",
                                        "plural": false,
                                        "selections": [
                                          (v1/*: any*/),
                                          (v7/*: any*/),
                                          (v13/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "account",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AccountNode",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v1/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "clientaccount",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ClientAccountNode",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "accountType",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v35/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "executionSet",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ExecutionNodeConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ExecutionNodeEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ExecutionNode",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "transaction",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "TransactionNode",
                                                "plural": false,
                                                "selections": (v18/*: any*/)
                                              },
                                              (v25/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "proceeds",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "executionDatetime",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v26/*: any*/),
                                              (v34/*: any*/),
                                              (v13/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "proceedsToDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "proceedsToDateBase",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "brokerOrder",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BrokerOrderNode",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "twsOrderId",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "twsPermId",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v27/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "quantityFilled",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "quantityLeft",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "stopPrice",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "trailStopRatio",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "trailStopOffset",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "lastSyncTime",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v17/*: any*/),
                                      (v24/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "ackedClientOrderId",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "brokerSideOrderId",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "ibExchange",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "IBExchangeNode",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "algoParams",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "OrderAlgoParamsNode",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "algo",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "orderalgoparamstwap",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OrderAlgoParamsTWAPNode",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "strategyType",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v8/*: any*/),
                                              (v9/*: any*/),
                                              (v36/*: any*/),
                                              (v13/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "orderalgoparamsvwap",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OrderAlgoParamsVWAPNode",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "maxVolumeRatio",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              (v8/*: any*/),
                                              (v9/*: any*/),
                                              (v36/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "neverTakeLiquidity",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "speedup",
                                                "args": null,
                                                "storageKey": null
                                              }
                                            ]
                                          },
                                          (v13/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "brokerorderamendmentSet",
                                        "storageKey": "brokerorderamendmentSet(orderBy:\"sequence\")",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "orderBy",
                                            "value": "sequence"
                                          }
                                        ],
                                        "concreteType": "BrokerOrderAmendmentNodeConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BrokerOrderAmendmentNodeEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "node",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "BrokerOrderAmendmentNode",
                                                "plural": false,
                                                "selections": [
                                                  (v13/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "limitPrice",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "previousLimitPrice",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  (v26/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "previousQuantity",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  (v17/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "blockingRevised",
                                                    "args": null,
                                                    "storageKey": null
                                                  },
                                                  (v15/*: any*/),
                                                  (v16/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "orderPtr",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderNode",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "orderapprovalcontractSet",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "OrderApprovalContractNodeConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OrderApprovalContractNodeEdge",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "node",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "OrderApprovalContractNode",
                                                "plural": false,
                                                "selections": [
                                                  (v13/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "approval",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "OrderApprovalNode",
                                                    "plural": false,
                                                    "selections": [
                                                      (v13/*: any*/),
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "portfolioOrder",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "PortfolioOrderNode",
                                                        "plural": false,
                                                        "selections": [
                                                          (v13/*: any*/),
                                                          (v17/*: any*/)
                                                        ]
                                                      },
                                                      (v15/*: any*/),
                                                      (v16/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "approvedAt",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "notifiedAt",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "remindedAt",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "proposal",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "OrderProposalNode",
                                                        "plural": false,
                                                        "selections": [
                                                          (v13/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "type",
                                                            "args": null,
                                                            "storageKey": null
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "rationaleUrl",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "approvedBy",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "UserNode",
                                                        "plural": false,
                                                        "selections": (v33/*: any*/)
                                                      },
                                                      (v17/*: any*/),
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "portfolio",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "PortfolioNode",
                                                        "plural": false,
                                                        "selections": [
                                                          (v13/*: any*/),
                                                          (v19/*: any*/),
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "account",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AccountNode",
                                                            "plural": false,
                                                            "selections": (v37/*: any*/)
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "actionLogs",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "ActionLogUserRequestNodeConnection",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "edges",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ActionLogUserRequestNodeEdge",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "node",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "ActionLogUserRequestNode",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v13/*: any*/),
                                                                  (v31/*: any*/),
                                                                  (v28/*: any*/),
                                                                  (v30/*: any*/),
                                                                  (v29/*: any*/),
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "user",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "UserNode",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v13/*: any*/),
                                                                      (v32/*: any*/)
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v13/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "tradeInvoice",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TradeInvoiceNode",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v22/*: any*/),
                                      (v21/*: any*/),
                                      (v23/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v35/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "transactions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TransactionNodeConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "TransactionNodeEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TransactionNode",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "commission",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "tax",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "transactionaccountchargeSet",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "TransactionAccountChargeNodeConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "TransactionAccountChargeNodeEdge",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "node",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "TransactionAccountChargeNode",
                                                        "plural": false,
                                                        "selections": [
                                                          (v13/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "amount",
                                                            "args": null,
                                                            "storageKey": null
                                                          },
                                                          (v34/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "feeType",
                                                            "args": null,
                                                            "storageKey": null
                                                          },
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "accountchargePtr",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AccountChargeNode",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "accountchargetenantportionSet",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "AccountChargeTenantPortionNodeConnection",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "edges",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "AccountChargeTenantPortionNodeEdge",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "LinkedField",
                                                                        "alias": null,
                                                                        "name": "node",
                                                                        "storageKey": null,
                                                                        "args": null,
                                                                        "concreteType": "AccountChargeTenantPortionNode",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          (v13/*: any*/),
                                                                          (v26/*: any*/),
                                                                          {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "tenant",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "TenantNode",
                                                                            "plural": false,
                                                                            "selections": (v37/*: any*/)
                                                                          }
                                                                        ]
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              },
                                                              (v13/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v12/*: any*/)
            ]
          },
          (v13/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PortfolioOrderDetailsContainerQuery",
    "id": null,
    "text": "query PortfolioOrderDetailsContainerQuery(\n  $portfolioOrderId: ID\n) {\n  viewer {\n    sideEnum: __type(name: \"Side\") {\n      enumValues {\n        description\n        name\n      }\n    }\n    orderTypeEnum: __type(name: \"OrderType\") {\n      enumValues {\n        description\n        name\n      }\n    }\n    orderStatusEnum: __type(name: \"OrderStatus\") {\n      enumValues {\n        description\n        name\n      }\n    }\n    portfolioOrderStatusEnum: __type(name: \"PortfolioOrderStatus\") {\n      enumValues {\n        description\n        name\n      }\n    }\n    exchanges {\n      edges {\n        node {\n          symbol\n          nextDaySession {\n            startTime\n            endTime\n          }\n          id\n        }\n      }\n    }\n    portfolioOrders(id: $portfolioOrderId) {\n      edges {\n        node {\n          ...PortfolioOrderDetails_portfolioOrder\n          id\n        }\n      }\n      count\n    }\n    id\n  }\n}\n\nfragment PortfolioOrderDetails_portfolioOrder on PortfolioOrderNode {\n  id\n  side\n  createdAt\n  updatedAt\n  status\n  bulkOrder {\n    id\n  }\n  portfolio {\n    id\n    trackingVueName\n    trackingVue {\n      id\n      name\n    }\n  }\n  account {\n    id\n    name\n  }\n  tradeInvoice {\n    pdf\n    pdfUrl\n    createdAt\n    updatedAt\n    state\n    id\n  }\n  stockOrders(orderBy: \"createdAt\") {\n    edges {\n      node {\n        ...StockOrderDetails_stockOrder\n        id\n      }\n    }\n  }\n}\n\nfragment StockOrderDetails_stockOrder on StockOrderNode {\n  parentOrder {\n    id\n  }\n  id\n  orderRef\n  status\n  pendingStatus\n  price\n  quantity\n  cashQuantity\n  side\n  createdAt\n  updatedAt\n  orderType\n  quantityToDate\n  executedQuantityToDate\n  matched\n  blockedHoldings\n  blockedProceeds\n  blockedBaseCharges\n  blockedLocalCharges\n  customCommission\n  advancedOrderType\n  actionLogs(orderBy: \"actionTime\") {\n    edges {\n      node {\n        actionId\n        actionType\n        actionTime\n        actionDescription\n        user {\n          fullName\n          id\n        }\n        id\n      }\n    }\n  }\n  contract {\n    id\n    currency\n    symbol\n    name\n    industry\n    ibConId\n    instrumentType\n    exchange {\n      name\n      symbol\n      id\n    }\n  }\n  account {\n    id\n    name\n    clientaccount {\n      id\n      accountType\n    }\n  }\n  portfolioOrder {\n    id\n  }\n  executionSet {\n    edges {\n      node {\n        transaction {\n          id\n        }\n        price\n        proceeds\n        executionDatetime\n        quantity\n        currency\n        id\n      }\n    }\n  }\n  proceedsToDate\n  proceedsToDateBase\n  brokerOrder {\n    id\n    twsOrderId\n    twsPermId\n    cashQuantity\n    quantityFilled\n    quantityLeft\n    stopPrice\n    trailStopRatio\n    trailStopOffset\n    lastSyncTime\n    status\n    orderRef\n    ackedClientOrderId\n    brokerSideOrderId\n    ibExchange {\n      id\n      symbol\n    }\n    algoParams {\n      algo\n      orderalgoparamstwap {\n        strategyType\n        startTime\n        endTime\n        allowPastEndTime\n        id\n      }\n      orderalgoparamsvwap {\n        id\n        maxVolumeRatio\n        startTime\n        endTime\n        allowPastEndTime\n        neverTakeLiquidity\n        speedup\n      }\n      id\n    }\n    brokerorderamendmentSet(orderBy: \"sequence\") {\n      edges {\n        node {\n          id\n          limitPrice\n          previousLimitPrice\n          quantity\n          previousQuantity\n          status\n          blockingRevised\n          createdAt\n          updatedAt\n        }\n      }\n    }\n  }\n  orderPtr {\n    orderapprovalcontractSet {\n      edges {\n        node {\n          id\n          approval {\n            id\n            portfolioOrder {\n              id\n              status\n            }\n            createdAt\n            updatedAt\n            approvedAt\n            notifiedAt\n            remindedAt\n            proposal {\n              id\n              type\n            }\n            rationaleUrl\n            approvedBy {\n              fullName\n              id\n            }\n            status\n            portfolio {\n              id\n              trackingVueName\n              account {\n                name\n                id\n              }\n            }\n            actionLogs {\n              edges {\n                node {\n                  id\n                  actionDescription\n                  actionId\n                  actionTime\n                  actionType\n                  user {\n                    id\n                    fullName\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  tradeInvoice {\n    id\n    pdfUrl\n    pdf\n    state\n    createdAt\n    updatedAt\n    portfolioOrder {\n      id\n    }\n  }\n  transactions {\n    edges {\n      node {\n        id\n        commission\n        tax\n        transactionaccountchargeSet {\n          edges {\n            node {\n              id\n              amount\n              currency\n              feeType\n              accountchargePtr {\n                accountchargetenantportionSet {\n                  edges {\n                    node {\n                      id\n                      quantity\n                      tenant {\n                        name\n                        id\n                      }\n                    }\n                  }\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '167c2dcd41834b8391ee2596396d9757';
module.exports = node;
